"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFICATION_BELL_ICON_BUTTON = exports.NOTIFICATION_BELL_ICON_BELL = void 0;
const NOTIFICATION_BELL_ICON_BUTTON = exports.NOTIFICATION_BELL_ICON_BUTTON = 'notification-bell-icon-button';
const NOTIFICATION_BELL_ICON_BELL = exports.NOTIFICATION_BELL_ICON_BELL = 'notification-bell-icon-bell';